import { render, staticRenderFns } from "./VTable.vue?vue&type=template&id=75666f7d&"
import script from "./VTable.vue?vue&type=script&lang=ts&"
export * from "./VTable.vue?vue&type=script&lang=ts&"
import style0 from "./VTable.vue?vue&type=style&index=0&id=75666f7d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports